import { render, staticRenderFns } from "./noLogin.vue?vue&type=template&id=386b4364"
import script from "./noLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./noLogin.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports